import { useSnackbar } from "material-ui-snackbar-provider";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { AutocompleteChangeReason } from "@mui/material";

import { MultipleAutocompleteChip } from "@/components/forms/MultipleAutocompleteChip";
import { ConfirmationDialog } from "@/components/modals/ConfirmationDialog";

export default function SaaSSelector({
  department,
  departments,
  setDepartments,
  saasList,
}) {
  const snackbar = useSnackbar();
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const { t } = useTranslation();

  const onChange = (
    saasItems: { id: number; name: string }[],
    reason: AutocompleteChangeReason,
  ) => {
    if (reason === "clear") {
      setConfirmationOpen(true);
    } else {
      let departmentsRefreshed = [];
      for (let i = 0; i < departments.length; i++) {
        const aDepartment = departments[i];
        if (aDepartment.id === department.id) {
          department.tags = saasItems;
          departmentsRefreshed.push(department);
        } else {
          departmentsRefreshed.push(aDepartment);
        }
      }
      setDepartments(departmentsRefreshed);
      snackbar.showMessage(t("Department updated"));
    }
  };

  return (
    <>
      <MultipleAutocompleteChip
        options={saasList}
        onChange={onChange}
        value={department.tags}
      />
      <ConfirmationDialog
        isShown={confirmationOpen}
        onConfirm={() => {
          onChange([], "removeOption");
          setConfirmationOpen(false);
        }}
        onConfirmText={t("Confirm")}
        onCancel={() => setConfirmationOpen(false)}
        onCancelText={t("Cancel")}
        title={t("Are you sure ?")}
        content={t("This will remove all of these tags.")}
      />
    </>
  );
}
